import { baseQuery } from './baseQuery';
import { type JsonDataItem } from '@g2u/ui-kit';


export const postSurvey = async (payload: JsonDataItem) => {
  const { data } = await baseQuery('survey', {
    type: 'POST',
    body: payload,
  });

  return data;
};
